export function deltaTransformPoint(
  matrix: DOMMatrix,
  point: { x: number; y: number }
) {
  const dx = point.x * matrix.a + point.y * matrix.c + 0;
  const dy = point.x * matrix.b + point.y * matrix.d + 0;
  return { x: dx, y: dy };
}
